export default function systemsToSelectOptions(systems) {
  return systems.map((system) => {
    return {
      value: system.id,
      label: system.systemName,
    };
  });
}



// WEBPACK FOOTER //
// ./src/utils/systemSelectFormatter.js